import { render, staticRenderFns } from "./AddWeaponModal.vue?vue&type=template&id=ece1eb8a&"
import script from "./AddWeaponModal.vue?vue&type=script&lang=js&"
export * from "./AddWeaponModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports